import Link from 'next/link';
import React from 'react';

import Heading from '@components/Heading';

const LinkList = ({
  title,
  subtitle = undefined,
  items = [],
  withHeader = true,
  containerClasses = '',
}) => {
  return (
    <>
      {withHeader && (
        <header className="fade fade-1 mb-8">
          {title && <Heading size="sm">{title}</Heading>}
          {subtitle && (
            <h4 className="font-inter text-base text-black">{subtitle}</h4>
          )}
        </header>
      )}

      <div className={`fade fade-2 gap-4 grid ${containerClasses}`}>
        {items.map((item) => (
          <Link
            href={item.href}
            as={item.asPath}
            key={`${item.href}${item.asPath}`}
          >
            <a
              className={`border border-gray-200 rounded-xl h-24 p-4 hover:trigger hover:shadow-md focus:shadow focus:outline-none focus:opacity-80 transition duration-200 ease-in-out`}
            >
              <div className="last:mb-0 hover:text-blue-100">
                <div className="text-base flex items-center">
                  {item.icon && (
                    <img
                      className="rounded mr-4"
                      src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/docs/icons/${item.icon}.svg`}
                      alt="icon"
                    />
                  )}

                  {item.logo && (
                    <figure className="rounded mr-4">{item.logo}</figure>
                  )}

                  <div
                    className={`text-black flex-1 justify-between font-inter flex font-semibold transition-colors duration-200 ease-in-out child-hoverable`}
                  >
                    <div className="flex-1">{item.title} </div>
                    <div className="flex-initial text-right whitespace-no-wrap opacity-0 hover:target">
                      {'->'}
                    </div>
                  </div>
                </div>
                {/*
                <h4 className="font-inter text-sm text-gray-500 leading-relaxed">
                {item.subtitle}
              </h4>
              */}
              </div>
            </a>
          </Link>
        ))}
      </div>
    </>
  );
};

export default LinkList;
